<template>
  <div id="app">
    <!-- <img alt="Vue logo" src="./assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/> -->
	<router-view/>
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'
import Home from './views/home.vue'

export default {
  name: 'app',
  components: {
    HelloWorld,
	Home
  }
}
</script>

<style>
	/*********************************通用样式**********************************************/
	*{margin:0;padding:0;font-family:"微软雅黑";color:#333; font-size: 14px; }
	body{margin: 0;padding: 0;}
	h1,h2,h3,h4,h5,h6{margin: 0;padding: 0;}
	a{text-decoration:none;outline:none;color:#333;}
	a:active,a:focus{outline: none; border:0; border:none;}
	img{border:none;margin: 0;padding: 0;}
	form,fieldset,legend{margin:0;padding:0; list-style:none;border:0; border:none;}
	input,button,textarea,select{font-size:100%;outline: none;resize: none; font-family:"微软雅黑";margin:0;padding:0; list-style:none;border:0; border:none; }
	ul li,ol dl{list-style: none;}
	
	/*清除浮动*/
	.clearfix:after{visibility:hidden;display:block;font-size:0;content:"\0020";clear:both;height:0;}
	.clearfix{*zoom:1;}
	
	/*左右浮动*/
	.fl{float: left;}
	.fr{float: right;}
	
	/*外阴影--内阴影*/
	.m_yyw{box-shadow: #f7f7f7 0px 0px 30px 5px;}
	.m_yyn{box-shadow: #f7f7f7 0px 0px 30px 5px inset;}
	
	/*卡片效果*/
	.m_card{box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);}
	
	/*一行文字溢出*/
	.m_text_overflow1 {white-space:nowrap;overflow:hidden;text-overflow:ellipsis; }
	
	/*多行文本溢出*/
	.m_text_overflow2 {overflow : hidden; text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2; -webkit-box-orient: vertical;}
	
	/*强制文本两端对齐*/
	.m_text_justify{text-align:justify;text-justify:inter-ideograph}
	
	
	/*  */
	.w_70{width: 70%;margin: 0 auto;}
	.w_80{width: 80%;margin: 0 auto;}
	
	
	
	/*修改提示文字的颜色*/
	input::-webkit-input-placeholder ,textarea::-webkit-input-placeholder { /* WebKit browsers */ 
		color: #FFFFFF; 
		font-size: 14px;
	} 
	input:-moz-placeholder,textarea:-moz-placeholder { /* Mozilla Firefox 4 to 18 */ 
		color: #FFFFFF; 
		font-size: 14px;
	} 
	input::-moz-placeholder ,textarea::-moz-placeholder{ /* Mozilla Firefox 19+ */ 
		color: #FFFFFF; 
		font-size: 14px;
	} 
	input:-ms-input-placeholder,textarea::-ms-input-placeholder{ /* Internet Explorer 10+ */ 
		color: #FFFFFF; 
		font-size: 14px;
	} 
	/*  */
	::-webkit-scrollbar {
		  /*滚动条整体样式*/
		  width : 5px;  /*高宽分别对应横竖滚动条的尺寸*/
		  height: 0px;
		  margin-left: 2px;
	}
	::-webkit-scrollbar-thumb {
		  /*滚动条里面小方块*/
		  border-radius: 0px;
		  box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
		  background   : #0051b0;
	}
	::-webkit-scrollbar-track {
		  /*滚动条里面轨道*/
		  box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
		  border-radius: 0px;
		  background   : #061348;
	}
	
	
	/* 弹窗样式 */
	.mk1_dialog{width: 100%;height: 100%;top: 0;left: 0;background-color: #021126d4;}
	.mk1_dialog .el-dialog{width: 450px;height: 450px;background-color: transparent;}
	.mk1_dialog .el-dialog .el-dialog__header{ position: absolute;right: 1%; top: 8%; z-index: 2222;}
	.mk1_dialog .el-dialog .el-dialog__header .el-dialog__title{display: none;}
	.mk1_dialog .el-dialog .el-dialog__header .el-dialog__headerbtn{}
	.mk1_dialog .el-dialog .el-dialog__header .el-dialog__headerbtn .el-dialog__close{color: #ffffff!important;}
	.mk1_dialog .el-dialog .el-dialog__body{}
	/* table */
	.el-table, .el-table__expanded-cell{background-color: transparent;}
	.el-table th.el-table__cell>.cell{color: #19e8fc!important;}
	.table-header{background-color: #124fa6!important;color: #ffffff;font-size: 12px;text-align: center;}
	.table-header th.el-table__cell{background-color: #124fa6!important;color: #19e8fc!important;font-size: 12px;text-align: center;}
	.el-table__body .el-table__row td.el-table__cell{text-align: center;}
	.el-table td.el-table__cell div{color: #FFFFFF;}
	.el-table tr{background-color: #010f23!important}
	.el-table .el-table__row--striped{background-color: #0a3b81!important;}
	.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{border-bottom: 0px!important;}
	
	.el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell{background: transparent!important;}
	.el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell{background: transparent!important;}
	.el-table--border::after, .el-table--group::after, .el-table::before{background-color:transparent!important;}
	.el-table, .el-table__expanded-cell{background-color: transparent!important;}
	
	.el-pagination{padding: 10px 5px!important;}
	/*  */
	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
	}
</style>
